<template>
	<div class="display-flex flex-row width-100">
		<FullProjectMenu :isOpen="useIsProjectMenuPinned" />
		<AppContentLayout :class="{ 'no-padding': isAnalyticsTab }" class="app-content-layout width-100">
			<template #header>
				<ManageAndCreateTopBar :featureType="featureType" :serviceSlug="serviceSlug" :serviceWorkspaceId="serviceWorkspaceId" />
			</template>
			<router-view class="content-padding" :class="{ 'no-padding': isAnalyticsTab }" />
		</AppContentLayout>
	</div>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { ANALYTICS_ROUTE_NAME } from '@/router/router.const';
import AppContentLayout from '@/views/AppLayout/AppContentLayout.vue';
import { useIsProjectMenuPinned } from '@/store/modules/appLayout/getters';
import FullProjectMenu from '@/views/AppLayout/AppNavigation/FullProjectMenu.vue';
import ManageAndCreateTopBar from '@/views/AppLayout/ManageAndCreate/ManageAndCreateTopBar.vue';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';

export default {
	name: 'ManageAndCreate',
	props: {
		featureType: { type: String },
		serviceSlug: { type: String },
		serviceWorkspaceId: { type: String },
	},
	components: {
		FullProjectMenu,
		AppContentLayout,
		ManageAndCreateTopBar,
	},
	computed: {
		...mapGettersShorthand({ useIsProjectMenuPinned }),
		isAnalyticsTab() {
			return CreateAndManageService.isRouteOrChildOfRoute(this.$route, ANALYTICS_ROUTE_NAME);
		},
	},
};
</script>

<style scoped lang="scss">
.app-content-layout {
	padding: 0 0 30px 0 !important;
	&.no-padding {
		padding: 0 !important;
		height: 100% !important;
	}
}
.content-padding {
	&.no-padding {
		padding: 0px !important;
	}
	padding: 0 50px 50px 50px !important;
}
</style>
